module.exports = __webpack_public_path__ + "img/vekonyvali_hollow2.3d96627c.svg";